/** O tema da interface: escuro, claro, ou o que o sistema disser.
 *
 *  O escuro é o de origem e continua a ser: é o que serve para olhar
 *  para geometria durante horas. O claro existe para o que SAI da
 *  aplicação, que é onde o preto atrapalha: imagens para um relatório,
 *  um documento, uma apresentação.
 *
 *  Não se confunde com o fundo da cena 3D, que já existia e é outra
 *  coisa (Aparência > Desenho). Uma pessoa pode querer a interface
 *  clara e a cena escura, e ao contrário.
 *
 *  Puro e sem React, para se testar sem DOM.
 */

export type Tema = 'escuro' | 'claro'
export type PreferenciaTema = Tema | 'sistema'

export const TEMA_KEY = 'vn2r.tema'

interface Armazenamento {
  getItem: (chave: string) => string | null
  setItem: (chave: string, valor: string) => void
}

function armazenamento(): Armazenamento | null {
  try {
    return typeof localStorage === 'undefined' ? null : localStorage
  } catch {
    return null
  }
}

export function lerPreferencia(
  store: Armazenamento | null = armazenamento(),
): PreferenciaTema {
  try {
    const v = store?.getItem(TEMA_KEY)
    if (v === 'claro' || v === 'escuro' || v === 'sistema') return v
  } catch {
    /* sem onde guardar */
  }
  // O escuro é o de origem: quem já usava a aplicação não deve vê-la
  // mudar de cor só porque passou a haver esta opção.
  return 'escuro'
}

export function gravarPreferencia(
  p: PreferenciaTema,
  store: Armazenamento | null = armazenamento(),
): void {
  try {
    store?.setItem(TEMA_KEY, p)
  } catch {
    /* sem onde guardar: dura esta sessão */
  }
}

/** O tema a aplicar, resolvendo o "sistema". */
export function resolverTema(
  preferencia: PreferenciaTema,
  sistemaPrefereClaro: boolean,
): Tema {
  if (preferencia === 'sistema') return sistemaPrefereClaro ? 'claro' : 'escuro'
  return preferencia
}

/** O sistema está em claro?
 *
 *  Um browser sem `matchMedia` (ou com ele bloqueado) devolve false, o
 *  que dá escuro, que é o de origem. */
export function sistemaPrefereClaro(): boolean {
  try {
    return (
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-color-scheme: light)').matches
    )
  } catch {
    return false
  }
}

/** Escreve o tema no documento. É o atributo que o CSS lê. */
export function aplicarTema(
  tema: Tema,
  raiz: { setAttribute: (n: string, v: string) => void } | null = typeof document ===
  'undefined'
    ? null
    : document.documentElement,
): void {
  raiz?.setAttribute('data-tema', tema)
}
